import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const emptyForm = { name: '', role: 'Security Guard', contactNo: '', salary: '', status: 'Active' };

export default function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);
  const [msg, setMsg] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/staff').then(r => setStaff(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm(emptyForm); setEditId(null); setShowModal(true); };
  const openEdit = (s) => {
    setForm({ name: s.name, role: s.role, contactNo: s.contactNo || '', salary: s.salary || '', status: s.status });
    setEditId(s._id);
    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/staff/${editId}`, form);
      else await api.post('/staff', form);
      setShowModal(false);
      setMsg(editId ? 'Staff updated!' : 'Staff added!');
      load();
    } catch (err) { setMsg(err.response?.data?.message || 'Error'); }
  };

  const deleteStaff = async (id) => {
    if (!window.confirm('Delete this staff member?')) return;
    await api.delete(`/staff/${id}`);
    load();
  };

  return (
    <Layout title="Staff Management">
      {msg && <div className="alert alert-info">{msg} <button style={{ float:'right', background:'none', border:'none', cursor:'pointer' }} onClick={() => setMsg('')}>✕</button></div>}

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">👥 Staff Members</h3>
          <button className="btn btn-primary" onClick={openAdd}>➕ Add Staff</button>
        </div>

        {loading ? (
          <div className="text-center" style={{ padding: 40 }}>Loading...</div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr><th>Name</th><th>Role</th><th>Contact</th><th>Monthly Salary</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {staff.length === 0 ? (
                  <tr><td colSpan={6} className="text-center" style={{ padding: 30, color: '#718096' }}>No staff added yet</td></tr>
                ) : staff.map(s => (
                  <tr key={s._id}>
                    <td><strong>{s.name}</strong></td>
                    <td>
                      <span className={`badge ${s.role === 'Security Guard' ? 'badge-warning' : 'badge-info'}`}>
                        {s.role === 'Security Guard' ? '🛡️' : '🧹'} {s.role}
                      </span>
                    </td>
                    <td>{s.contactNo || '-'}</td>
                    <td>PKR {(s.salary || 0).toLocaleString()}</td>
                    <td><span className={`badge ${s.status === 'Active' ? 'badge-success' : 'badge-secondary'}`}>{s.status}</span></td>
                    <td>
                      <div className="flex gap-10">
                        <button className="btn btn-warning btn-sm" onClick={() => openEdit(s)}>✏️ Edit</button>
                        <button className="btn btn-danger btn-sm" onClick={() => deleteStaff(s._id)}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editId ? 'Edit Staff' : 'Add Staff Member'}</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSave}>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Name *</label>
                    <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required placeholder="Full name" />
                  </div>
                  <div className="form-group">
                    <label>Role *</label>
                    <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                      <option>Security Guard</option>
                      <option>Cleaning Staff</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Contact No</label>
                    <input value={form.contactNo} onChange={e => setForm(f => ({ ...f, contactNo: e.target.value }))} placeholder="Phone number" />
                  </div>
                  <div className="form-group">
                    <label>Monthly Salary (PKR)</label>
                    <input type="number" value={form.salary} onChange={e => setForm(f => ({ ...f, salary: e.target.value }))} min="0" placeholder="0" />
                  </div>
                  <div className="form-group">
                    <label>Status</label>
                    <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                      <option>Active</option>
                      <option>Inactive</option>
                    </select>
                  </div>
                </div>
                <div className="form-actions">
                  <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary">💾 Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
